import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { api } from '~/api';
import { sessionActions } from '~/api/session';
import { envConfigSelectors } from '~/selectors';

import { secureRoutes } from './secure-routes';
import { getAccessToken } from '../utils';

import { storageCanBeSet } from '@JohnLewisPartnership/pecr-util';
import { errorPageActions } from '~/components';

export const withSecureRoute = (Component) =>
  class extends PureComponent {
    static displayName = 'WithSecureRoute';

    static propTypes = {
      pathname: PropTypes.string.isRequired,
      dispatchCreateSession: PropTypes.func.isRequired,
      dispatchSetErrorStatus: PropTypes.func.isRequired,
    };

    state = {
      showComponent: false,
      sessionExists: false,
    };

    componentDidMount() {
      this.checkAccessToken();
    }

    componentDidUpdate(prevProps, prevState) {
      const { sessionExists } = this.state;
      const { pathname } = this.props;

      if (prevState.sessionExists !== sessionExists || prevProps.pathname !== pathname) {
        this.checkAccessToken();
      }
    }

    isSecureRoute = (pathname) => secureRoutes.some((path) => pathname.indexOf(path) === 0);

    checkAccessToken = async () => {
      const { pathname, dispatchCreateSession, dispatchSetErrorStatus } = this.props;
      const { sessionExists } = this.state;

      if (this.isSecureRoute(pathname)) {
        if (!storageCanBeSet('Essentials')) {
          return dispatchSetErrorStatus('COOKIES_ERROR');
        }

        this.setState({
          showComponent: false,
        });
        try {
          if (!sessionExists) {
            const accessToken = await getAccessToken();

            if (accessToken) {
              dispatchCreateSession()
                .then(() => {
                  this.setState({
                    showComponent: true,
                    sessionExists: true,
                  });
                })
                .catch((error) => {
                  console.error('Failed to create session:', error);
                });
            } else {
              window.location = api.getSignInUrl();
            }
          } else {
            this.setState({
              showComponent: true,
            });
          }
        } catch (error) {
          console.error('Error in checkAccessToken:', error);
          return error;
        }
      } else {
        this.setState({
          showComponent: true,
        });
      }
    };

    render() {
      const { showComponent } = this.state;
      if (showComponent) {
        return <Component {...this.props} />;
      }
      return null;
    }
  };

export const mapStateToProps = (state) => ({
  pathname: envConfigSelectors.selectCurrentPathname(state) ?? '',
});

const mapDispatchToProps = {
  dispatchCreateSession: sessionActions.createSession,
  dispatchSetErrorStatus: errorPageActions.setErrorStatus,
};

export const ConnectedWithSecureRoute = (Component) =>
  connect(mapStateToProps, mapDispatchToProps)(withSecureRoute(Component));
